import { observer } from 'mobx-react';
import React from 'react';
import { GAME_STATES } from '../js/ids';
import PopupStore, { POPUPS_IDS } from '../stores/PopupStore';
import { store } from '../stores/store';
import AdvisorPopup from './AdvisorPopup/AdvisorPopup';
import AepPopup from './AepPopup/AepPopup';
import AleasPopup from './AleasPopup/AleasPopup';
import Debug from './debug/Debug';
import DescriptionPopup from './DescriptionPopup/DescriptionPopup';
import './game.css';
import GameOverPopup from './GameOverPopup/GameOverPopup';
import GoalsPopup from './GoalsPopup/GoalsPopup';
import IndicatorHistoryPopup from './IndicatorHistoryPopup/IndicatorHistoryPopup';
import MeetingOverlayPopup from './MeetingOverlayPopup/MeetingOverlayPopup';
import StartMenu from './Menu/StartMenu';
import MyFarmPopup from './MyFarmPopup/MyFarmPopup';
import NewGameAlertPopup from './NewGameAlertPopup/NewGameAlertPopup';
import ProfilePopup from './ProfilePopup/ProfilePopup';
import UIJauge from './RainbowGauge/UIJauge';
import ReportPopup from './ReportPopup/ReportPopup';
import TreePopup from './TreePopup/TreePopup';
import BottomLeftUI from './ui/BottomLeftUI';
import BottomRightUI from './ui/BottomRightUI';
import GameBackground from './ui/GameBackground';
import TopCenterUI from './ui/TopCenterUI';
import TopLeftUI from './ui/TopLeftUI';
import TopRightUI from './ui/TopRightUI';
import './ui/ui.css';

// import AppState, { GAME_STATUS } from '../../../../BCG/AnalyticsAcceleration/src/js/AppState';


function Game() {

  if(store.gameState === GAME_STATES.LOADING || store.gameState === GAME_STATES.LOADED) return <StartMenu />

  if(store.debugMode === "1") return <Debug />

  return (
    <div id="game">

      <GameBackground />
      <UIJauge/>

      {!store.isGameOver && <TopRightUI />}

      <BottomRightUI />


      {!store.isMeetingInfinite && <TopCenterUI />}

      <TopLeftUI />
      <BottomLeftUI />

      {PopupStore.list.map(popup => {
        if(popup.id === POPUPS_IDS.REPORT) return <ReportPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.MYFARM) return <MyFarmPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.GOALS) return <GoalsPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.ALEAS) return <AleasPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.AEPS) return <AepPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.IND_HISTORY) return <IndicatorHistoryPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.TREES) return <TreePopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.GAME_OVER) return <GameOverPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.ADVISOR) return <AdvisorPopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.PROFILE) return <ProfilePopup data={popup.data} key={popup.id} />
        if(popup.id === POPUPS_IDS.DESCRIPTION) return <DescriptionPopup data={popup.data} key={popup.id}/>
        if(popup.id === POPUPS_IDS.NEW_GAME_ALERT) return <NewGameAlertPopup data={popup.data} key={popup.id}/>
        if(popup.id === POPUPS_IDS.MEETING_OVERLAY) return <MeetingOverlayPopup data={popup.data} key={popup.id} />
        return null
      })}


    </div>
  )
}

export default observer(Game)
